import React from "react";
import { Button, ButtonToolbar, Drawer, Icon, Nav, Notification } from "rsuite";
import { AdmediaryContext } from "../../@Context/AdmediaryContext";
import { FormInstance } from "rsuite/lib/Form/Form";
import { FormContext } from "../../@Context/FormContext";
import _ from "lodash";
import { Query } from "../../@Utils/AdmediaryApi";
import ProductCategoryForm from "./ProductCategories/ProductCategoryForm";
import ProductCategorySourceList from "./ProductCategories/CategorySources/ProductCategorySourceList";

type ProductCategoryType = {
  category_id: number;
  refreshData?: () => void;
};

const EditProductCategory: React.FC<ProductCategoryType> = ({
  category_id = 0,
  refreshData,
}) => {
  const Admediary = React.useContext(AdmediaryContext);
  const Forms = React.useContext(FormContext);
  const initFormValue = {
    category_name: "",
    category_id: 0,
    enable_filters: [],
    show_in_reports: [],
  };
  const [activeKey, setActiveKey] = React.useState("main");

  const [formValue, setFormValue] = React.useState(initFormValue);
  const mainFormRef = React.createRef<FormInstance>();

  const handleCallback = (formValue: any) => {
    setFormValue({
      ...formValue,
      ...{
        category_id: category_id,
      },
    });
  };

  const handleSave = () => {
    const node = mainFormRef && mainFormRef.current;

    if (node && !node.check()) {
      return;
    }

    // Build data for saving
    // We should clone data to change it
    const data: any = _.cloneDeep(formValue);

    data.default_allow = Forms.defaultAllow;

    // Checkbox value is array and empty when unchecked. Should be transform to 0 or 1
    if (Array.isArray(data.enable_filters)) {
      data.enable_filters = data.enable_filters.length
        ? data.enable_filters[0]
        : 0;
    }

    if (Array.isArray(data.show_in_reports)) {
      data.show_in_reports = data.show_in_reports.length
        ? data.show_in_reports[0]
        : 0;
    }

    (async () => {
      try {
        await Query("product_category_update", data);
        Notification.success({
          title: "Success",
          description: "Product Category has been updated",
        });

        Admediary.closeDrawer();

        if (refreshData instanceof Function) {
          refreshData();
        }
      } catch (e) {
        console.log("error", e);
        Notification.error({
          title: "Error",
          duration: 60000,
          description: e,
        });
      } finally {
      }
    })();
  };

  const tabs = [
    {
      key: "main",
      title: "Category",
      content: (
        <ProductCategoryForm
          category_id={category_id}
          formRef={mainFormRef}
          parentCallback={handleCallback}
        />
      ),
    },
  ];

  if (category_id > 0) {
    tabs.push(
      ...[
        {
          key: "sources",
          title: "Sources",
          content: (
            <ProductCategorySourceList
              category_id={category_id}
              category_name={formValue.category_name}
            />
          ),
        },
      ]
    );
  }

  return (
    <>
      <Drawer.Header className="buyer-sidebar-header">
        <Drawer.Title
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {!!category_id ? "Edit" : "Add"} Product Category
          {Admediary.drawerFull ? (
            <Icon
              icon="window-restore"
              onClick={Admediary.restoreDrawer}
              style={{ marginTop: "3px", cursor: "pointer" }}
            />
          ) : (
            <Icon
              icon="window-maximize"
              onClick={Admediary.maximizeDrawer}
              style={{ marginTop: "3px", cursor: "pointer" }}
            />
          )}
        </Drawer.Title>
        <Nav
          activeKey={activeKey}
          appearance="tabs"
          onSelect={(eventKey) => {
            setActiveKey(eventKey);
          }}
          style={{ marginTop: 10 }}
        >
          {tabs.map((tab: any, index: number) => (
            <Nav.Item eventKey={tab.key} key={index}>
              {tab.title}
            </Nav.Item>
          ))}
        </Nav>
      </Drawer.Header>
      <Drawer.Body>
        {tabs.map((tab: any, index: number) => (
          <div
            key={index}
            id={"main_content_" + tab.key}
            style={{
              display: activeKey === tab.key ? "block" : "none",
              minHeight: "100px", // put the loading icon down off the tabs
            }}
          >
            {tab.content}
          </div>
        ))}
      </Drawer.Body>
      <Drawer.Footer style={{ textAlign: "center" }}>
        <ButtonToolbar style={{ marginBottom: 18 }}>
          <Button
            onClick={handleSave}
            appearance="primary"
            disabled={Admediary.userDisable}
          >
            Save
          </Button>
          <Button onClick={() => Admediary.closeDrawer()} appearance="subtle">
            Cancel
          </Button>
        </ButtonToolbar>
      </Drawer.Footer>
    </>
  );
};

export default EditProductCategory;
